import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { css } from "VSSUI/Util";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { NotificationType, Notification } from "VersionControl/Scenarios/Shared/Notifications/NotificationStore";

export type Renderers = IDictionaryStringTo<(specialContent: any) => JSX.Element>;

export function renderInto(element: HTMLElement, props: NotificationAreaProps): void {
    ReactDOM.render(
        <NotificationArea {...props}/>,
        element);
}

export function unmountComponent(element: HTMLElement): void {
    ReactDOM.unmountComponentAtNode(element);
}

export interface NotificationAreaProps {
    className?: string;
    notifications: Notification[];
    renderers?: Renderers;
    onDismiss?(notification: Notification): void;
}

/**
 * A component to display notifications.
 */
export const NotificationArea = (props: NotificationAreaProps): JSX.Element =>
    <div>
        {
            props.notifications.map(notification => {
                const message = renderSpecialContent(notification, props.renderers) || notification.message;
                return message &&
                    <MessageBar
                        key={notification.key}
                        className={css("notification-message-bar", props.className)}
                        severity={mapToMessageBarSeverity[notification.type]}
                        buttonProps={createButtonProps(notification.buttonTitle, notification.buttonCallback)}
                        onDismiss={notification.isDismissable && props.onDismiss ? () => props.onDismiss(notification) : undefined}>
                            {message}
                    </MessageBar>;
            })
        }
    </div>;

const mapToMessageBarSeverity: { [key: number]: MessageBarSeverity} = {
    [NotificationType.success]: MessageBarSeverity.Success,
    [NotificationType.info]: MessageBarSeverity.Info,
    [NotificationType.warning]: MessageBarSeverity.Warning,
    [NotificationType.error]: MessageBarSeverity.Error,
};

function renderSpecialContent(notification: Notification, renderers: Renderers): JSX.Element {
    const renderer = renderers && renderers[notification.specialType];
    return renderer && renderer(notification.specialContent);
}

function createButtonProps(text: string, onClick: () => void) {
    return text && [{ text, onClick }];
}
